import { NgModule } from '@angular/core';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OrganizationPageComponent } from './organization-page/organization-page.component';
import { InfoLegalComponent } from './legal-entity/info/info-legal.component';
import { EditLegalComponent } from './legal-entity/edit/edit-legal.component';
import { InfoIndividualComponent } from './individual/info/info-individual.component';
import { EditIndividualComponent } from './individual/edit/edit-individual.component';
import { SharedModule } from '../../shared/shared.module';
import { OrganisationRoutingModule } from './organisation-routing.module';
import { OrganizationEditComponent } from './organization-edit/organization-edit.component';
import { OpenAddressSelectorDirective } from './address-selector/open-address-selector.directive';
import { AddressSelectorComponent } from './address-selector/address-selector.component';
import { ModalModule } from '../../core/modal/modal.module';

@NgModule({
  imports: [
    MatMenuModule,
    SharedModule,
    FormsModule,
    OrganisationRoutingModule,
    ReactiveFormsModule,
    ModalModule,
  ],
  exports: [
    EditLegalComponent,
    EditIndividualComponent,
  ],
  declarations: [
    OrganizationPageComponent,
    OrganizationEditComponent,
    InfoLegalComponent,
    EditLegalComponent,
    InfoIndividualComponent,
    EditIndividualComponent,
    AddressSelectorComponent,
    OpenAddressSelectorDirective,
  ],
  providers: [],
})
export class OrganisationModule {
}
